import { inboxesConstants } from 'store/constants';
import {
  EachInboxResponse,
  Inboxes,
  InboxI,
} from 'store/models/Inboxes';

export interface InboxesStoreStateI {
  isLoading: boolean;
  inboxAddresses: string[];
  addressToDetailMap: { [address: string]: InboxI };
  color: string | null;
  error: string | null;
}

const initialState = {
  isLoading: false,
  inboxAddresses: [] as string[],
  addressToDetailMap: {} as { [address: string]: InboxI },
  color: null,
  error: null,
};

export const inboxes = (
  state = initialState,
  action: {
    type: string;
    payload: {
      inboxes?: EachInboxResponse[];
      error?: string;
      email?: string;
      id?: number;
    };
  },
) => {
  switch (action.type) {
    case inboxesConstants.INBOXES_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case inboxesConstants.INBOXES_SUCCESS:
      const inboxAddresses = Inboxes.inboxesListApiToInboxAddresses(
        action.payload.inboxes,
      );
      const addressToDetailMap = Inboxes.inboxesListApiToInboxesNav(
        action.payload.inboxes,
      );
      return {
        ...state,
        isLoading: false,
        inboxAddresses,
        addressToDetailMap,
      };
    case inboxesConstants.INBOXES_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};
